<template>
    <div class="hotel-info-services">
        <v-card v-if="serviceGroup.length || services.length" variant="outlined" class="mb-5">
            <v-card-title class="hotel-info-services__card-title text-h6">
                {{ $t('filterTitles.services') }}
            </v-card-title>
            <v-card-text class="text--primary">
                <v-row v-if="serviceGroup.length" dense>
                    <v-col
                        v-for="group in serviceGroup"
                        :key="group.id"
                        cols="6"
                        sm="3"
                        class="hotel-info-services__group text-capitalize mb-5"
                    >
                        <div class="hotel-info-services__group-name font-weight-bold">{{ group.name }}</div>
                        <div
                            v-for="(service, index) in group.services.service.filter(({active}) => active)"
                            :key="`${group.id}_${index}`"
                        >
                            <hotel-info-services-label :service="service" />
                        </div>
                    </v-col>
                </v-row>
                <v-row v-else-if="services.length" dense>
                    <v-col v-for="(service, index) in services" :key="index" cols="6" sm="3" class="text-capitalize">
                        <hotel-info-services-label :service="service" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card v-if="roomService.length" variant="outlined">
            <v-card-title class="text-h6 font-weight-light">
                {{ $t('filterTitles.roomServices') }}
            </v-card-title>
            <v-card-text class="text--primary">
                <v-row dense>
                    <v-col v-for="(service, index) in roomService" :key="index" cols="6" sm="3" class="text-capitalize">
                        <hotel-info-services-label :service="service" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import HotelInfoServicesLabel from '~src/components/hotels/snippets/hotelInfoServicesLabel.src'

    @Component({components: {HotelInfoServicesLabel}})
    export class HotelInfoServices extends Vue {
        @Prop() info

        get services() {
            return (
                (this.info || hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo).services?.service.filter(
                    service => service.active
                ) || []
            )
        }

        get serviceGroup() {
            return (this.info || hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo).services?.serviceGroup || []
        }

        get roomService() {
            return (this.info || hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo).services?.roomService || []
        }
    }

    export default HotelInfoServices
</script>
